import { Notification } from 'expo-notifications';
import moment from 'moment';
import React, { FC } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { TouchableOpacity } from 'react-native-gesture-handler';
import Colors from '../../constants/Colors';
import FontStyles from '../../constants/FontStyle';
import StyledIcon from '../StyledIcon';

interface IProp {
    data: Notification,
    remove?: any
}

const NotificationCard: FC<IProp> = ({ data, remove }) => {
    return <>
        <View style={styles.container}>
            <View style={styles.header}>
                <View style={styles.titleContainer}>
                    <Text style={styles.title}>{data.request.content.title}
                        {` `}<Text style={styles.date}>{moment().to(data.date)}</Text>
                    </Text>
                    <Text style={styles.bodyText}>{data.request.content.body}</Text>
                </View>
                <TouchableOpacity
                    style={styles.buttonContainer}
                    onPress={() => remove && remove()}
                >
                    <StyledIcon
                        iconOnly
                        iconName='trash-2'
                        iconLibrary='Feather'
                        size={18}
                        iconColor={Colors.dangerText}
                    />
                </TouchableOpacity>
            </View>
        </View>
    </>
}

export default NotificationCard

const styles = StyleSheet.create({
    container: {
        backgroundColor: Colors.whiteColor,
        paddingHorizontal: 16,
        paddingTop: 10,
        paddingBottom: 16,

        borderBottomColor: Colors.borderColor,
        borderBottomWidth: 1,
        borderStyle: 'solid'
    },
    header: {
        flexDirection: 'row',
        padding: 3,
    },
    titleContainer: {
        flex: 1,
    },
    title: {
        ...FontStyles.medium,
        ...FontStyles.size13,
        ...FontStyles.lh15,
        ...FontStyles.dark,
    },
    date: {
        ...FontStyles.gray,
        ...FontStyles.size11,
        paddingLeft: 10
    },
    buttonContainer: {
        padding: 6,
    },
    bodyText: {
        ...FontStyles.normal,
        ...FontStyles.size12,
        ...FontStyles.lh14,
        ...FontStyles.dark,
        marginTop: 6
    }
})